import React from "react";
import ReactDOM from "react-dom";

const defaultPortalId = 'portal';

export default class Portal extends React.Component<{portalId?: string}, {}> {

    componentDidUpdate(prevProps, prevState, snapshot) {
        if (prevProps.portalId !== this.props.portalId && this.mounted) {
            this.holder = document.getElementById(this.props.portalId || defaultPortalId);
        }
    }

    componentDidMount() {
        // The portal element is inserted in the DOM tree after
        // the Modal's children are mounted, meaning that children
        // will be mounted on a detached DOM node. If a child
        // component requires to be attached to the DOM tree
        // immediately when mounted, for example to measure a
        // DOM node, or uses 'autoFocus' in a descendant, add
        // state to Modal and only render the children when Modal
        // is inserted in the DOM tree.
        this.mounted = true;
        if (!this.holder) {
            this.holder = document.getElementById(this.props.portalId || defaultPortalId);
            this.forceUpdate();
        }
    }

    componentWillUnmount() {
        this.mounted = false;
        if (this.holder) {
            this.holder = null;
            this.forceUpdate();
        }
    }

    render() {
        if (!this.holder) {
            return null;
        }
        return ReactDOM.createPortal(
            this.props.children,
            this.holder,
        );
    }

}